import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  FormLabel,
  Button,
  Typography,
} from "@material-ui/core";
import { useParams } from "react-router";
import { connect } from "react-redux";
import {
  apiDownloadFileData,
  apiEndpoints,
  apiGetByIdRequest,
} from "src/utils/api/api";
import React, { useEffect, useState } from "react";
import actions from "src/duck/global/actions";
import { FileIcon, defaultStyles } from "react-file-icon";
import SvgIcon from "@material-ui/core/SvgIcon";
import Skeleton from "@material-ui/lab/Skeleton";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import fileDownload from "js-file-download";
import { useNavigate, NavLink as RouterLink } from "react-router-dom";
import UserAndDate from "src/components/common/UserAndDate";
import { userHasAtLeastOnePermission } from "src/utils/userutils";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  accordion: {
    marginTop: theme.spacing(1.5),
  },
  fileicon: {
    fontSize: "2.7rem",
    marginTop: theme.spacing(2),
  },
  filename: {
    margin: theme.spacing(1),
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const DocumentPreview = ({
  globalData,
  enableGlobalLoader,
  disableGlobalLoader,
  titleUpdate,
  setRedirectPath,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const { documentId } = useParams();
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const [documentData, setDocumentData] = useState(null);

  const sourcePath = window.location.pathname;

  useEffect(() => {
   
    enableGlobalLoader();
    apiGetByIdRequest(apiEndpoints.getDocumentDetails.path, documentId, true)
      .then((data) => {
        setDocumentData(data);
        setLoading(false);
        titleUpdate(data.name);
        disableGlobalLoader();
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response) {
          if (error.response.status === 403) {
            navigate("/nieuprawnionydostep");
          } else if (error.response.status === 401) {
            setRedirectPath(sourcePath);
            navigate("/logowanie");
          }
        }
      });
    return () => {};
 
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleFileDownload = (documentDetailsId, filename, version) => {
    if (version) {
      apiDownloadFileData(
        `${apiEndpoints.documentFileData.path}${documentDetailsId}/${version}`,
        true
      ).then((result) => {
        fileDownload(result, filename);
      });
    } else {
      apiDownloadFileData(
        `${apiEndpoints.documentFileData.path}${documentDetailsId}`,
        true
      ).then((result) => {
        fileDownload(result, filename);
      });
    }
  };

  return (
    <Card className={clsx(classes.root)} {...rest}>
      <Box component="main">
        <Grid container className={classes.root}>
          <Grid item xs={12} elevation={2}>
            <FormControl
              fullWidth
              className={classes.formcontrol}
              variant="outlined"
            >
              <Box>
                {loading ? (
                  <Skeleton />
                ) : (
                  <Box>
                    <SvgIcon className={classes.fileicon}>
                      <FileIcon
                        extension={documentData.versions[0].fileType}
                        {...defaultStyles[documentData.versions[0].fileType]}
                      />
                    </SvgIcon>
                    <Typography className={classes.filename} display="inline">
                      {documentData.versions[0].originalFileName}
                    </Typography>

                    <Button
                      variant="contained"
                      color="default"
                      className={classes.button}
                      startIcon={<CloudDownloadIcon />}
                      onClick={() =>
                        handleFileDownload(
                          documentData.versions[0].id,
                          documentData.versions[0].originalFileName
                        )
                      }
                    >
                      Pobierz plik
                    </Button>
                  </Box>
                )}
              </Box>
            </FormControl>
            <FormControl
              fullWidth
              className={classes.formcontrol}
              variant="outlined"
            >
              <FormLabel className={classes.paddingBottom} component="label">
                Opis
              </FormLabel>
              <Typography>
                {loading ? <Skeleton /> : documentData.versions[0].description ? documentData.versions[0].description : '-'}
              </Typography>
            </FormControl>

            <Grid container spacing={3}>
              {userHasAtLeastOnePermission(globalData, [
                "user_admin",
                "super_admin",
              ]) ? (
                <>
                  <Grid item xs>
                    <FormControl
                      fullWidth
                      className={classes.formcontrol}
                      variant="outlined"
                    >
                      <FormLabel
                        className={classes.paddingBottom}
                        component="label"
                      >
                        Kto i kiedy utworzył
                      </FormLabel>
                      <Box>
                        {loading ? (
                          <Skeleton />
                        ) : (
                          <UserAndDate
                            username={documentData.versions[0].createdBy}
                            date={documentData.versions[0].createdAt}
                            separator=", "
                          />
                        )}
                      </Box>
                    </FormControl>
                  </Grid>
                  <Grid item xs>
                    <FormControl
                      fullWidth
                      className={classes.formcontrol}
                      variant="outlined"
                    >
                      <FormLabel
                        className={classes.paddingBottom}
                        component="label"
                      >
                        Kto i kiedy modyfikował
                      </FormLabel>
                      <Box>
                        {loading ? (
                          <Skeleton />
                        ) : (
                          <UserAndDate
                            username={documentData.versions[0].updatedBy}
                            date={documentData.versions[0].updatedAt}
                            separator=", "
                          />
                        )}
                      </Box>
                    </FormControl>
                  </Grid>
                </>
              ) : (
                <></>
              )}

              <Grid item xs>
                <FormControl
                  fullWidth
                  className={classes.formcontrol}
                  variant="outlined"
                >
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Kto i kiedy opublikował
                  </FormLabel>
                  <Box>
                    {loading ? (
                      <Skeleton />
                    ) : (
                      <UserAndDate
                        username={documentData.publishedBy}
                        date={documentData.publishedAt}
                        separator=", "
                      />
                    )}
                  </Box>
                </FormControl>
              </Grid>
            </Grid>

            <FormControl
              fullWidth
              className={classes.formcontrol}
              variant="outlined"
            >
              <FormLabel component="label">Wersje dokumentu</FormLabel>

              {loading ? (
                <Skeleton />
              ) : (
                documentData.versions.map((document) => (
                  <Accordion
                    key={document.id}
                    expanded={expanded === `panel${document.id}`}
                    onChange={handleChange(`panel${document.id}`)}
                    className={classes.accordion}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography className={classes.heading}>
                        Wersja {document.versionNum}
                      </Typography>
                      <Typography className={classes.secondaryHeading}>
                        {document.originalFileName}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={3}>
                        <Grid item xs>
                          <FormLabel
                            className={classes.paddingBottom}
                            component="label"
                          >
                            Nazwa dokumentu
                          </FormLabel>
                          <Typography>{document.name}</Typography>
                        </Grid>
                        <Grid item xs>
                          <Button
                            variant="contained"
                            color="default"
                            className={classes.button}
                            startIcon={<CloudDownloadIcon />}
                            onClick={() =>
                              handleFileDownload(
                                document.id,
                                document.originalFileName,
                                document.versionNum
                              )
                            }
                          >
                            Pobierz plik
                          </Button>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                    <AccordionDetails>
                      <Grid container spacing={3}>
                        <Grid item xs>
                          <FormLabel
                            className={classes.paddingBottom}
                            component="label"
                          >
                            Opis
                          </FormLabel>
                          <Typography>{document.description ? document.description : '-'}</Typography>
                        </Grid>
                        {userHasAtLeastOnePermission(globalData, [
                          "user_admin",
                          "super_admin",
                        ]) ? (
                          <>
                            <Grid item xs>
                              <FormControl
                                fullWidth
                                className={classes.formcontrol}
                                variant="outlined"
                              >
                                <FormLabel
                                  className={classes.paddingBottom}
                                  component="label"
                                >
                                  Kto i kiedy utworzył
                                </FormLabel>
                                <Box>
                                  {loading ? (
                                    <Skeleton />
                                  ) : (
                                    <UserAndDate
                                      username={document.createdBy}
                                      date={document.createdAt}
                                      separator=", "
                                    />
                                  )}
                                </Box>
                              </FormControl>
                            </Grid>
                            <Grid item xs>
                              <FormControl
                                fullWidth
                                className={classes.formcontrol}
                                variant="outlined"
                              >
                                <FormLabel
                                  className={classes.paddingBottom}
                                  component="label"
                                >
                                  Kto i kiedy modyfikował
                                </FormLabel>
                                <Box>
                                  {loading ? (
                                    <Skeleton />
                                  ) : (
                                    <UserAndDate
                                      username={document.updatedBy}
                                      date={document.updatedAt}
                                      separator=", "
                                    />
                                  )}
                                </Box>
                              </FormControl>
                            </Grid>
                          </>
                        ) : (
                          <></>
                        )}
                        {/* <Grid item xs>
                          <FormControl
                            fullWidth
                            className={classes.formcontrol}
                            variant="outlined"
                          >
                            <FormLabel
                              className={classes.paddingBottom}
                              component="label"
                            >
                              Kto i kiedy opublikował
                            </FormLabel>
                            <Box>
                              {loading ? (
                                <Skeleton />
                              ) : (
                                <UserAndDate
                                  username={document.publishedBy}
                                  date={document.publishedAt}
                                  separator=", "
                                />
                              )}
                            </Box>
                          </FormControl>
                        </Grid> */}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                ))
              )}
            </FormControl>
            <Box className={classes.paddingtop}>
              <Button
                color="primary"
                className={classes.button}
                component={RouterLink}
                to={
                  documentData?.parentFolderId
                    ? `/dokumenty/${documentData.parentFolderId}/`
                    : `/dokumenty`
                }
              >
                Zamknij
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  setRedirectPath: (redirectPath) =>
    dispatch(actions.setRedirectPath(redirectPath))
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentPreview);
